import { render, staticRenderFns } from "./BaseHelpWidget.vue?vue&type=template&id=10bc938f&scoped=true&"
import script from "./BaseHelpWidget.vue?vue&type=script&lang=js&"
export * from "./BaseHelpWidget.vue?vue&type=script&lang=js&"
import style0 from "./BaseHelpWidget.vue?vue&type=style&index=0&id=10bc938f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc938f",
  null
  
)

export default component.exports